const initAccountNav = () => {
  const $navToggle = document.querySelector('.account-nav__toggle');
  const $navPanel = document.getElementById('account-nav');
  const mobileQuery = window.matchMedia(`(max-width: ${window.theme.breakpoints.large}px)`);
  let isExpanded = true;

  const toggleNav = () => {
    isExpanded = !isExpanded;
    $navToggle.setAttribute('aria-expanded', isExpanded);
    $navPanel.setAttribute('hidden', !isExpanded);
  };

  const handleResize = e => {
    if (e.matches) {
      $navPanel.setAttribute('hidden', true);
      isExpanded = false;
    } else {
      $navToggle.setAttribute('aria-expanded', false);
      $navPanel.removeAttribute('hidden');
      isExpanded = true;
    }
  };

  if (mobileQuery.matches) {
    $navPanel.setAttribute('hidden', true);
    isExpanded = false;
  }

  if ($navToggle) {
    $navToggle.addEventListener('click', toggleNav);
  }

  mobileQuery.addListener(e => {
    handleResize(e);
  });
};

export default initAccountNav;
